<template>
  <el-dropdown size="small" class="d2-mr">
    <span class="btn-text">你好， {{info.name}}</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="editPasword">
        <d2-icon name="refresh" class="d2-mr-5" />修改密码
      </el-dropdown-item>
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off" class="d2-mr-5" />退出登录
      </el-dropdown-item>
    </el-dropdown-menu>
    <el-dialog title="修改密码"
               :visible.sync="editPaswDialog" @close="closeEditPasw"
               width="50%">
       <el-form :model="editPasForm" :rules="fromrule" ref="editPasRef">
            <el-form-item label="用户名" :label-width="formLabelWidth">
                <el-input v-model="editPasForm.username" disabled></el-input>
            </el-form-item>
            <el-form-item label="原密码" prop="oldpsw" :label-width="formLabelWidth" >
                <el-input v-model="editPasForm.oldpsw" autocomplete="off" type='password' placeholder='请输入原密码'></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newpas" :label-width="formLabelWidth" >
                <el-input v-model="editPasForm.newpas" autocomplete="off" type='password' placeholder='请输入新密码'></el-input>
                <div class="psw-tip">密码必须包含英文大小写、数字、字符</div>
            </el-form-item>
            <el-form-item label="密码确认" prop="pwd" :label-width="formLabelWidth" >
                <el-input v-model="editPasForm.pwd" autocomplete="off" type='password' placeholder='请再次输入新密码'></el-input>
            </el-form-item>
        </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="closeEditPasw">取 消</el-button>
        <el-button type="primary"
                   @click="saveEditPas">确 定</el-button>
      </span>
    </el-dialog>
  </el-dropdown>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data(){
    var validatePassword = (rule, value, callback) => {
      if (!/\S/.test(value)) {
        callback(new Error('密码不能为空'))
      } else {
        callback()
      }
    }
    var validateComfirmPassword = (rule, value, callback) => {
      if (!/\S/.test(value)) {
        callback(new Error('确认密码不能为空'))
      } else if (this.editPasForm.newpas !== value) {
        callback(new Error('确认密码与密码输入不一致'))
      } else {
        callback()
      }
    }
    return {
      editPaswDialog:false,
      formLabelWidth:'100px',
      editPasForm:{
        username:'',
        oldpsw:'',
        newpas:'',
        pwd:''
      },
      fromrule:{
        newpas:[
            { validator: validatePassword, trigger: 'blur' },
            { min: 1, max: 30,message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        pwd:[
            { validator: validateComfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  created(){
    this.editPasForm.username = this.info.name
  },
  computed: {
    ...mapState('d2admin/user', [
      'info'
    ])
  },
  methods: {
    ...mapActions('d2admin/account', [
      'logout'
    ]),
    /**
     * @description 登出
     */
    logOff () {
      this.logout({
        vm: this,
        confirm: true
      })
    },
    editPasword(){
      this.editPaswDialog = true
      this.$nextTick(() => {
        this.$refs.editPasRef.resetFields()
      })
    },
    saveEditPas(){
      this.$refs.editPasRef.validate(valid => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl("/sys/user/password"),
            method: "post",
            data: {
              password: this.editPasForm.oldpsw,
              newPassword: this.editPasForm.pwd,
              username: this.editPasForm.username
            }
          }).then((data) => {
            console.log(data);
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.editPaswDialog = false
                }
              })
            } else { this.$message.error(data.msg) }
          })
        }
      
      })
    },
    closeEditPasw(){
      this.editPaswDialog = false
    }
  }
}
</script>
<style scoped>
.psw-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>